import theme from '@vromo/ui/components/theme';

export default {
    container: {
        width: '50vw',
        minWidth: '350px',
        marginBottom: '80px'
    },
    contentContainer: {
        width: '100%',
        paddingTop: '20px',
        paddingBottom: '20px',
        paddingLeft: '35px',
        paddingRight: '35px'
    },
    pageTitle: {
        textAlign: 'center',
        fontSize: '16pt',
        fontWeight: 'bold',
        color: theme.darkText
    },
    submitButton: {
        marginRight: 40,
        marginBottom: 40
    },
    overlayTitle: {
        textAlign: 'center',
        fontSize: '16pt',
        fontWeight: 'normal',
        color: theme.darkText
    },
    overlayZipCodeList: {
        marginTop: 20,
        marginBottom: 20
    },
    floatingButton: {
        position: 'absolute',
        bottom: '8%',
        right: '10%'
    }
};
